module.exports = __webpack_public_path__ + "img/b4.d10e906.jpg";